import React, { useEffect, useState, useContext } from 'react'
import {
  CButton,
  CModal,
  CModalBody,
  CModalFooter,
  CRow,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CFormLabel,
  CModalHeader,
  CFormCheck,
} from '@coreui/react'
import { AppContext } from 'src/views/context/app'
import Loading from 'react-fullscreen-loading'
import useAxios from 'axios-hooks'
import { VENUE_LIST_API } from 'src/views/utils/urls'
import { getThumbnail, raiseToast } from 'src/views/utils/helper'
import { isEmpty } from 'lodash'
import ImageNotFound from '../../assets/image-not-found.jpg'
import { GlobalContext } from 'src/views/context/GlobalState'
import moment from 'moment'
import '../artistModal/artistModal.scss'

const VenueModal = () => {
  const { setLoader, loader, venueModalProps, setVenueModalProps } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const { type, mappedVenuetId, selectCallback } = venueModalProps
  const [venueData, setVenueData] = useState([])
  const [selectedVenueId, setSelectedVenueId] = useState(
    type === 'single' ? `${mappedVenuetId}` : [...mappedVenuetId],
  )

  const [{ data: venueList, loading: venueListLoading }] = useAxios({
    url: VENUE_LIST_API,
    method: 'get',
  })

  useEffect(() => {
    setLoader(venueListLoading)
  }, [venueListLoading])

  useEffect(() => {
    if (venueList && venueList.success) {
      console.log('venueList.data', venueList.data)
      setVenueData(venueList.data)
    }
  }, [venueList])

  const handleVenueSelect = (info) => {
    if (type === 'single') {
      info._id === selectedVenueId ? setSelectedVenueId('') : setSelectedVenueId(info._id)
      return
    }
    let temp = selectedVenueId
    let venueIndex = selectedVenueId.findIndex((e) => e === info._id)
    if (venueIndex > -1) {
      temp = selectedVenueId.filter((e) => e !== info._id)
    } else {
      temp.push(info._id)
    }

    setSelectedVenueId([...temp])
  }

  const handleSelect = () => {
    if (isEmpty(selectedVenueId)) {
      raiseToast('error', 'Please Select a Venue.')
      return
    }
    if (type === 'single') {
      const venueObj = venueData.find((info) => info._id === selectedVenueId)
      if (selectedVenueId && venueObj) {
        selectCallback(venueObj)
        setVenueModalProps({})
      }
      return
    }

    let venueArr = []

    for (let i = 0; i < selectedVenueId.length; i++) {
      const id = selectedVenueId[i]
      const venueObj = venueData.find((info) => info._id === id)
      if (venueObj) {
        venueArr.push(venueObj)
      }
    }
    selectCallback(venueArr)
    setVenueModalProps({})
  }

  const handleActiveClasses = (info) => {
    let flag = false
    if (type === 'single') {
      flag = info._id === selectedVenueId
    } else {
      flag = selectedVenueId.findIndex((e) => e === info._id) > -1
    }

    return flag
  }
  return (
    <CModal scrollable size="xl" visible={true} alignment="center" className="zero-border-modal">
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader>
        <CRow className="mx-5 mt-3">
          <p style={{ fontSize: '20px', fontWeight: 'bold' }} className="h4">
            Venue List
          </p>
          <CFormLabel style={{ fontSize: '13px' }}>
            Following are the Venue list which are already in your CMS.
          </CFormLabel>
        </CRow>
      </CModalHeader>
      <CModalBody style={{ padding: '4px' }}>
        <div
          style={{ height: '40rem' }}
          className="table-responsive  static-scrollbar-class"
          id="scrollableDiv"
        >
          <CTable style={{ tableLayout: 'fixed' }} className="" hover>
            <CTableHead
              style={{
                position: 'sticky',
                top: '-0.001rem',
                zIndex: 10,
                background: 'white',
              }}
            >
              <CTableRow>
                <CTableHeaderCell
                  style={{
                    textAlign: 'center',
                    fontSize: '19px',
                    fontWeight: '500',
                    width: '29%',
                  }}
                >
                  <span className="ml-4">Thumbnail</span>
                </CTableHeaderCell>
                <CTableHeaderCell style={{ fontSize: '19px', fontWeight: '500', width: '24.3%' }}>
                  Name
                </CTableHeaderCell>
                <CTableHeaderCell style={{ fontSize: '19px', fontWeight: '500', width: '24.3%' }}>
                  Address
                </CTableHeaderCell>
                <CTableHeaderCell style={{ fontSize: '19px', fontWeight: '500', width: '22.3%' }}>
                  Created on
                </CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody style={{ zIndex: 5, fontSize: '19px' }} className="px-2">
              {!isEmpty(venueData) ? (
                venueData.map((info, index) => {
                  let activeFlag = handleActiveClasses(info)
                  return (
                    <CTableRow
                      key={index}
                      className={`py-4 cursor-pointer ${activeFlag ? 'selcted-artist' : ''}`}
                      onClick={() => handleVenueSelect(info)}
                    >
                      <CTableDataCell
                        align="middle"
                        className="flex justify-content-center align-items-center py-4"
                      >
                        <CFormCheck
                          type="radio"
                          className=""
                          name={info._id}
                          id={info._id}
                          value=""
                          checked={activeFlag}
                        />
                        <img
                          className="mx-5"
                          src={getThumbnail(
                            userSessionObj.session_data.cf_domain_name,
                            info.thumbnail.s3_key,
                          )}
                          alt={info.name}
                          onError={({ currentTarget }) => {
                            currentTarget.onerror = null // prevents looping
                            currentTarget.src = ImageNotFound
                          }}
                          style={{ width: '8.1rem', height: '4.556rem' }}
                        />
                      </CTableDataCell>
                      <CTableDataCell align="middle">{info.name}</CTableDataCell>
                      <CTableDataCell align="middle">
                        <p>{info.address}</p>
                      </CTableDataCell>
                      <CTableDataCell align="middle">
                        {moment(info.created_date).format('DD MMM YYYY')}
                      </CTableDataCell>
                    </CTableRow>
                  )
                })
              ) : (
                <CTableDataCell colSpan="7" style={{ textAlign: 'center' }}>
                  <h6 className="mt-3">No Venue Added</h6>
                </CTableDataCell>
              )}
            </CTableBody>
          </CTable>
        </div>
      </CModalBody>
      <CModalFooter className="px-5">
        <CButton
          style={{ color: 'black', border: '1px solid #bdbdbd', fontSize: '1.1rem' }}
          className="mx-4 bg-white rounded-1 btn-focus-none"
          onClick={() => setVenueModalProps({})}
        >
          Cancel
        </CButton>
        <CButton
          style={{ fontSize: '1.1rem' }}
          className=" bg-black rounded-1 btn-focus-none"
          onClick={handleSelect}
        >
          Select
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default VenueModal
